import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.1754 16.1429C11.1754 16.5241 11.4844 16.8331 11.8656 16.8331C12.2468 16.8331 12.5558 16.5241 12.5558 16.1429V10.4324C12.5558 10.0512 12.2468 9.74219 11.8656 9.74219C11.4844 9.74219 11.1754 10.0512 11.1754 10.4324V16.1429ZM11.2539 8.40802C11.4263 8.56806 11.6325 8.64808 11.8725 8.64808C12.1126 8.64808 12.3172 8.56806 12.4865 8.40802C12.6589 8.24491 12.745 8.05102 12.745 7.82635C12.745 7.5986 12.6589 7.40471 12.4865 7.24467C12.3172 7.08156 12.1126 7 11.8725 7C11.6325 7 11.4263 7.08156 11.2539 7.24467C11.0846 7.40471 11 7.5986 11 7.82635C11 8.05102 11.0846 8.24491 11.2539 8.40802Z"
        fill="currentColor"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-info-check-filled" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
